<app-header icon="back" title="_EditSpot_" backText="_ViewSpot_" showNav="false" changed="{{changedVal}}"></app-header>
<div class="body-container edit-job-page">
  <app-add-edit-job (changed)="isChanged($event)" mode="edit"></app-add-edit-job>
</div>